export default __webpack_public_path__ + "dist/media/done.0d65da46.svg";